"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerInfosRequestT = exports.ServerInfosRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * Allows to ask generic infos about the server,
 * like the local ip address, the version of the server, the java version,
 * the current working dir and other information we might want to show in the gui
 * for information/debug purposes
 */
class ServerInfosRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsServerInfosRequest(bb, obj) {
        return (obj || new ServerInfosRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsServerInfosRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new ServerInfosRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static startServerInfosRequest(builder) {
        builder.startObject(0);
    }
    static endServerInfosRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createServerInfosRequest(builder) {
        ServerInfosRequest.startServerInfosRequest(builder);
        return ServerInfosRequest.endServerInfosRequest(builder);
    }
    unpack() {
        return new ServerInfosRequestT();
    }
    unpackTo(_o) { }
}
exports.ServerInfosRequest = ServerInfosRequest;
class ServerInfosRequestT {
    constructor() { }
    pack(builder) {
        return ServerInfosRequest.createServerInfosRequest(builder);
    }
}
exports.ServerInfosRequestT = ServerInfosRequestT;
